import React from 'react';
import {
  BrowserRouter as BaseRouter,
  Switch,
  Route as BaseRoute,
} from 'react-router-dom';
import EnsureGuest from '../../containers/EnsureGuest/EnsureGuest';
import EnsureAuthenticated from '../../containers/EnsureAuthenticated/EnsureAuthenticated';
import Content from '../Content/Content';
import routeList from './routeList';

const routeRenderer = (props) => () => {
  const { auth, guest, preventRedirect } = props;

  if (auth) {
    return (
      <EnsureAuthenticated preventRedirect={preventRedirect || false} id="KEEKEKEK">
        <BaseRoute {...props} />
      </EnsureAuthenticated>
    );
  }

  if (guest) {
    return (
      <EnsureGuest preventRedirect={preventRedirect || false}>
        <BaseRoute {...props} />
      </EnsureGuest>
    );
  }

  return <BaseRoute {...props} />;
};

const route = (props) => {
  const { key, path } = props;

  return (
    <BaseRoute
      exact
      key={key}
      path={path}
      render={routeRenderer({ exact: true, ...props })}
    />
  );
};

const AppRouter = () => {
  return (
      <BaseRouter>
        <Content>
          <Switch>{routeList(route)}</Switch>
        </Content>
      </BaseRouter>
  );
};

export default AppRouter;
